/* eslint-disable no-redeclare */
/**
 * van11y-accessible-modal-tooltip-aria - ES2015 accessible modal tooltip system, using ARIA (compatible IE9+ when transpiled)
 * @version v2.3.1
 * @link https://van11y.net/accessible-modal-tooltip/
 * @license MIT : https://github.com/nico3333fr/van11y-accessible-modal-tooltip-aria/blob/master/LICENSE
 */
'use strict';

!function (t) {
  function o(t) {
    t.parentNode.removeChild(t);
  }
  var e = 'js-tooltip',
    i = 'label_tooltip',
    l = 'span',
    a = 'container',
    n = 'is-active',
    d = 'tooltip',
    s = 'data-tooltip-prefix-class',
    r = 'data-tooltip-text',
    c = 'data-tooltip-content-id',
    u = 'data-tooltip-title',
    p = 'data-tooltip-focus-toid',
    m = 'data-tooltip-close-text',
    f = 'data-tooltip-close-title',
    T = 'data-tooltip-close-img',
    g = 'dialog',
    b = 'p',
    v = 'tooltip__close',
    A = 'js-tooltip-close',
    C = 'js-tooltip-close',
    h = 'data-content-back-id',
    k = 'data-focus-back',
    I = 'tooltip__wrapper',
    x = 'tooltip__content',
    L = 'js-tooltip-content',
    B = 'tooltip__closeimg',
    _ = 'modal-close__text',
    y = 'tooltip-title',
    M = 'tooltip__title',
    j = "a[href], area[href], input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]",
    E = 'js-dialogtooltip',
    P = 'js-dialogtooltip',
    N = 'role',
    w = 'open',
    F = 'aria-labelledby',
    H = function H(o) {
      return t.getElementById(o);
    },
    D = function D(t, o) {
      t.classList ? t.classList.add(o) : t.className += ' ' + o;
    },
    O = function O(t, o) {
      t.classList ? t.classList.remove(o) : t.className = t.className.replace(new RegExp('(^|\\b)' + o.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    },
    S = function S(t, o) {
      return t.classList ? t.classList.contains(o) : new RegExp('(^| )' + o + '( |$)', 'gi').test(t.className);
    },
    q = function q(t, o) {
      t.parentNode.insertBefore(o, t), o.appendChild(t);
    },
    R = function R(t, o) {
      for (var e = !1, i = t.parentNode; i && e === !1;) S(i, o) === !0 ? e = !0 : i = i.parentNode;
      return e === !0 ? i.getAttribute('id') : '';
    },
    $ = function $(t) {
      var o = E,
        e = t.modalTooltipPrefixClass + d,
        i = t.modalTooltipPrefixClass + I,
        l = t.modalTooltipPrefixClass + v,
        a = t.modalTooltipCloseImgPath ? '<img src="' + t.modalTooltipCloseImgPath + '" alt="' + t.modalTooltipCloseText + '" class="' + B + '" />' : '<span class="' + _ + '">\n' + t.modalTooltipCloseText + '\n</span>',
        n = t.modalTooltipPrefixClass + x,
        s = t.modalTooltipPrefixClass + M,
        r = '' !== t.modalTooltipTitle ? '<h1 id="' + y + '" class="' + s + '">\n' + t.modalTooltipTitle + '\n</h1>' : '',
        c = '<button type="button" class="' + C + ' ' + l + '" id="' + A + '" title="' + t.modalTooltipCloseTitle + '" ' + h + '="' + t.modalTooltipContentId + '" ' + k + '="' + t.modalTooltipFocusBackId + '">\n' + a + '\n</button>',
        u = t.modalTooltipText;
      if ('' === u && t.modalTooltipContentId) {
        var p = H(t.modalTooltipContentId);
        p && (u = '<div id="' + L + '">\n' + p.innerHTML + '\n</div', p.innerHTML = '');
      } else u = '<' + b + '>\n' + u + '\n</' + b + '>';
      return '<dialog id="' + o + '" class="' + e + ' ' + P + '" ' + N + '="' + g + '" ' + w + ' ' + F + '="' + y + '">\n<div role="document" class="' + i + '">\n' + c + '\n<div class="' + n + '">\n ' + r + '\n' + u + '\n</div>\n</div>\n</dialog>';
    },
    K = function K(t) {
      if (o(t.modalTooltip), '' !== t.contentBackId) {
        var e = H(t.contentBackId);
        e && (e.innerHTML = t.modalTooltipContent);
      }
      if (t.modalTooltipFocusBackId) {
        var i = H(t.modalTooltipFocusBackId);
        i && i.focus();
      }
    },
    z = function z() {
      var o = arguments.length <= 0 || void 0 === arguments[0] ? t : arguments[0];
      return [].slice.call(o.querySelectorAll('.' + e));
    },
    G = function G(o) {
      var d = arguments.length <= 1 || void 0 === arguments[1] || arguments[1];
      z(o).forEach(function (o) {
        var e = Math.random().toString(32).slice(2, 12),
          n = o.hasAttribute(s) === !0 ? o.getAttribute(s) + '-' : '';
        o.setAttribute('id', i + e);
        var d = t.createElement(l);
        d.setAttribute('class', n + a), q(o, d);
      }), d && ['click', 'keydown'].forEach(function (o) {
        t.body.addEventListener(o, function (t) {
          S(t.target, e) === !0 && 'click' === o && S(t.target, n) === !1 && !function () {
            var o = t.target,
              e = o.hasAttribute(s) === !0 ? o.getAttribute(s) + '-' : '',
              i = o.hasAttribute(r) === !0 ? o.getAttribute(r) : '',
              l = o.hasAttribute(c) === !0 ? o.getAttribute(c) : '',
              a = o.hasAttribute(u) === !0 ? o.getAttribute(u) : '',
              d = o.hasAttribute(m) === !0 ? o.getAttribute(m) : '',
              g = o.hasAttribute(f) === !0 ? o.getAttribute(f) : d,
              b = o.hasAttribute(T) === !0 ? o.getAttribute(T) : '',
              v = o.hasAttribute(p) === !0 ? o.getAttribute(p) : '',
              C = H(E);
            if (C) {
              var I = H(A),
                x = H(L) ? H(L).innerHTML : '',
                B = I.getAttribute(k),
                _ = H(B),
                y = I.getAttribute(h);
              K({
                modalTooltip: C,
                modalTooltipContent: x,
                modalTooltipFocusBackId: B,
                contentBackId: y
              }), O(_, n);
            }
            setTimeout(function () {
              o.insertAdjacentHTML('afterend', $({
                modalTooltipText: i,
                modalTooltipPrefixClass: e,
                modalTooltipTitle: a,
                modalTooltipCloseText: d,
                modalTooltipCloseTitle: g,
                modalTooltipCloseImgPath: b,
                modalTooltipContentId: l,
                modalTooltipFocusBackId: o.getAttribute('id')
              }));
            }, 50), setTimeout(function () {
              var t = H(A);
              if ('' !== v) {
                var o = H(v);
                o ? o.focus() : t.focus();
              } else t.focus();
            }, 51), D(o, n), t.preventDefault();
          }();
          var i = R(t.target, C);
          if ((t.target.getAttribute('id') === A || '' !== i) && 'click' === o) {
            var l = H(E),
              a = H(L) ? H(L).innerHTML : '',
              d = H(A),
              g = d.getAttribute(k),
              b = H(g),
              v = d.getAttribute(h);
            K({
              modalTooltip: l,
              modalTooltipContent: a,
              modalTooltipFocusBackId: g,
              contentBackId: v,
              fromId: t.target.getAttribute('id')
            }), O(b, n), b.focus();
          }
          var I = R(t.target, P),
            x = H(E);
          if (x && 'click' === o && t.target.getAttribute('id') !== E && '' === I) {
            var d = H(A);
            d.click(), S(t.target, n) === !0 && t.preventDefault();
          }
          if (x && 'keydown' === o) {
            var a = H(L) ? H(L).innerHTML : '',
              d = H(A),
              g = d.getAttribute(k),
              v = d.getAttribute(h),
              b = H(g),
              B = [].slice.call(x.querySelectorAll(j));
            27 === t.keyCode && (K({
              modalTooltip: x,
              modalTooltipContent: a,
              modalTooltipFocusBackId: g,
              contentBackId: v
            }), O(b, n), b.focus()), 9 === t.keyCode && B.indexOf(t.target) >= 0 && (t.shiftKey ? t.target === B[0] && (B[B.length - 1].focus(), t.preventDefault()) : t.target === B[B.length - 1] && (B[0].focus(), t.preventDefault()));
          }
        }, !0);
      });
    },
    J = function Q() {
      G(), document.removeEventListener('DOMContentLoaded', Q);
    };
  document.addEventListener('DOMContentLoaded', J), window.van11yAccessibleModalTooltipAria = G;
}(document);